import "../styles/Hero.css";
import { useNavigate } from "react-router-dom";
function Hero() {
  const navigate=useNavigate();
  return (
    <section className="hero">

      <h1>
        Creators of purposeful,
        <span> Enduring Brands</span>
      </h1>

      <p>
        Grownex is a branding and marketing consultancy
        focused on creating commercially effective,
        scalable identities.
      </p>

      <div className="hero-buttons">
        <button className="outline-btn" onClick={()=>{navigate("/contact")}}>
          Start a conversation
        </button>

        <button className="orange-btn" onClick={()=>{navigate("/work")}}>
          View our work
        </button>
      </div>

    </section>
  );
}

export default Hero;